import Iframe from 'react-iframe'
import { FC, useCallback } from 'react'
import { FloatingPaneLayout } from 'components/features/pfm/FloatingPaneLayout/FloatingPaneLayout'
import styles from 'components/features/fastlink/FastlinkPane/FastlinkPane.styl'
import { ProviderId, MixedCompositeId } from 'interfaces/linkage'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { getMixedAccountsActionCreator, FetchMissingAccountsAction } from 'actions/linkageActions'

type FastlinkPaneProps = {
  onCancel?: () => void
  mode: 'add' | 'edit'
  provider_id?: ProviderId
  provider_account_id?: MixedCompositeId
}

export const IFRAME_BASE_URL = 'api/v1/fast-link/'

export const FastlinkPane: FC<FastlinkPaneProps> = (props) => {
  const {
    mode = 'add',
    onCancel,
    provider_id,
    provider_account_id,
  } = props

  const flowMode = mode === 'add' ? 'add-flow' : 'edit-flow'
  const id = mode === 'add' ? provider_id : provider_account_id?.split(':').pop()

  const url = IFRAME_BASE_URL + flowMode + '/' + id + '/'

  const dispatch = useStoreDispatch()
  const handleCancel = useCallback(() => {
    dispatch(new FetchMissingAccountsAction({}))
    dispatch(getMixedAccountsActionCreator.request({}))
    !!onCancel && onCancel()
  }, [dispatch, onCancel])

  return (
    <FloatingPaneLayout
      type='advisor'
      onClose={ handleCancel }
      bodyClassName={ styles.fastlinkPanePreset }
    >
      <Iframe
        url={ url }
        id='fastlinkFrame'
        className={ styles.iframe }
      />
    </FloatingPaneLayout>
  )
}
